import {Perfil} from "./perfil";
import {Municipio} from "./municipio";

export class Usuario {
	public cod_usuario: number;
	public txt_nome: string;
	public txt_nome_prefeito: string;
	public num_cpf: number;
	public num_telefone: number;
	public txt_cargo: string;
	public txt_orgao: string;
	public txt_unidade: string;
	public txt_email: string;
	public cod_perfil: number;
	public txt_senha: string;
	public txt_confirmar_senha: string;
	public txt_situacao: string;
	public num_cnpj: string;
	public flg_externo: boolean;
	public cod_municipio: number;
	public txt_sigla_uf: string;
	public municipio: Municipio;
	public perfil: Perfil
	public txt_username: string;
}
